/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function AnnouncementFromJSON(json) {
    return AnnouncementFromJSONTyped(json, false);
}
export function AnnouncementFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        title: !exists(json, 'title') ? undefined : json['title'],
        content: !exists(json, 'content') ? undefined : json['content'],
        publicStatus: !exists(json, 'public_status') ? undefined : json['public_status'],
        publicSince: !exists(json, 'public_since') ? undefined : json['public_since'],
        isRead: !exists(json, 'is_read') ? undefined : json['is_read'],
        createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
        updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at']
    };
}
export function AnnouncementToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        title: value.title,
        content: value.content,
        public_status: value.publicStatus,
        public_since: value.publicSince,
        is_read: value.isRead,
        created_at: value.createdAt,
        updated_at: value.updatedAt
    };
}
